import { compareVersion } from '@mx/util/compare-version';
import page from '../components/ErrorPage.vue';
import {env} from '@/common';

const errorPage = {} as any;

errorPage.install = (Vue: any, options: any) => {
  const router = options.router;
  ifShowErrorPage().then(() => {
    // 低版本
    // 1.动态增加 error 路由
    router.addRoutes([{
      path: '/error',
      name: 'errorPage',
      component: page
    }]);
    // 2.跳转至报错页面
    router.push('/error');
  });
};

function ifShowErrorPage(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (env.isNative && !env.isHarmony) {
      KNB.ready(() => {
        KNB.getAppInfo({
          success: (data: any) => {
            // 安卓为TitansX，ios为titansx
            const titansxVersion = data.TitansX || data.titansx;
            if (compareVersion(titansxVersion, '11.15') === -1) {
              // 进入错误页面
              resolve();
            }
          },
          fail: (err: any) => {
            console.log(err);
          }
        });
      });
    }
  });
}

export default errorPage;
